var BT_001 = {
  value: 'BT-001',
  label: 'Sole Trader'
};
var BT_002 = {
  value: 'BT-002',
  label: 'Limited company'
};
var BT_003 = {
  value: 'BT-003',
  label: 'Partnership'
};
var OTHER = {
  label: 'Other',
  value: 'other'
};
var BT_004 = {
  value: 'BT-004',
  label: 'Charity'
};
var BT_005 = {
  value: 'BT-005',
  label: 'Club'
};
var BT_006 = {
  value: 'BT-006',
  label: 'LLP'
};
var BT_007 = {
  value: 'BT-007',
  label: 'Public Organisation'
};
var BT_008 = {
  value: 'BT-008',
  label: 'Society'
};
export var businessTypes = {
  BT_001: BT_001,
  BT_002: BT_002,
  BT_003: BT_003,
  BT_004: BT_004,
  BT_005: BT_005,
  BT_006: BT_006,
  BT_007: BT_007,
  BT_008: BT_008,
  OTHER: OTHER
};